import React from 'react';
import DateTimeDisplay from './DateTimeDisplay';
import { useCountdown } from './useCountdown';

const ExpiredNotice = () => {
  const  datetimeout="0";
  return (
    <div className="show-counter expired-notice">
      <span>Expired</span>
    </div>
  );
};
/*  <DateTimeDisplay value={days} type={'Days'} isDanger={days <= 3} />
  <p>:</p>
  <DateTimeDisplay value={hours} type={'Hours'} isDanger={false} />
  <p>:</p>*/
const ShowCounter = ({ days, hours, minutes, seconds }) => {
  return (
    <div className="show-counter">

        <DateTimeDisplay value={seconds} type={'Seconds'} isDanger={false} />

    </div>
  );
};

const CountdownTimer = ({ targetDate }) => {
  const [days, hours, minutes, seconds] = useCountdown(targetDate);
  if (days + hours + minutes + seconds <= 0) {
    return <ExpiredNotice />;
  } else {
    return (
      <ShowCounter
        days={days}
        hours={hours}
        minutes={minutes}
        seconds={seconds}
      />
    );
  }
};

export default CountdownTimer;
